module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00061.4afede08.jpg";